import IconButton from '@/components/chat-history/IconButton';
import { Dropdown } from 'antd';
import { useState } from 'react';
import { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import './Feedback.scss';
import urm from '@public/urm';
import Other from '@/common/helper/other';
import globalStore from '@/store/global';
import wsStore from '../store';

const Button = ({ className, icon, onClick }) => (
  <IconButton
    icon={icon}
    iconClassName={['size-16px text-[#00000066]', className].join(' ').trim()}
    onClick={onClick}
  />
);

function Feedback(props) {
  const store = wsStore.currentStore;
  const { msg_id, prompt, messageItem } = props;
  const feedbackReasons = globalStore.cloudConfig.feedbackReasons;
  const [open, setOpen] = useState(false);
  const [negativeOpen, setNegativeOpen] = useState(false);
  const [inputText, setInputText] = useState('');
  const [selectDataList, setSelectDataList] = useState([]);
  const successType = useRef('');
  const activeType = useRef('');

  const handleSubmit = type => {
    if (!selectDataList.length && !inputText) {
      return Other.toast('请选择或填写反馈的内容!', "error");
    }
    let arr = [...selectDataList];
    if (inputText.trim()) {
      arr.push(inputText);
    }

    const urmData = {
      feedback_reason: arr.join(',').replace(/\,/g, '|'),
      like_type: activeType.current,
      tag: 'single',
      content: messageItem.prompt || '',
      message_id: msg_id || '',
      // mes_id : this.messageId,
      coversation_id: store.chatId,
      // qid: String(userStore.uid),
      result: messageItem.result || '',
    };
    try{
      if(messageItem.page?.length){
        urmData.summary_web_url = messageItem.page[0].url;
      }
    } catch(e){};
    store.log({
      action : "act",
      arrt : urmData.like_type == "like" ? "feedback_like" : "feedback_dislike",
      ext : urmData.content,
      role_id : messageItem.role_id,
      message_id : messageItem.msg_id,
    });
    urm.report(urmData)
      .then(res => {
        if (res.code == 0) {
          Other.toast('反馈成功!', "success");
          activeType.current == 'like'
            ? setOpen(false)
            : setNegativeOpen(false);
          successType.current = activeType.current;
          activeType.current = '';
        }
      })
      .catch(err => {
        console.log(err);
        Other.toast('反馈失败!', "error");
      });
  };

  const reset = () => {
    setSelectDataList([]);
    setInputText('');
  };

  useEffect(() => {
    // 请求云控数据
    return () => {
      setInputText('');
    };
  }, []);
  const dropList = type => {
    return (
      <div
        className="w-[292px] p-[16px] bg-white rounded-[16px]"
        style={{ boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.1)' }}
      >
        <div className="w-full font-bold text-[16px] left-[22px] mb-[12px]">
          反馈
        </div>
        <div className="w-full mb-[16px] flex flex-wrap gap-[8px]">
          {feedbackReasons
            .filter(x => x.type === activeType.current)
            .map((x, index) => {
              const checked = selectDataList.includes(x.content);
              return (
                <div
                  key={index}
                  className={`h-[32px] cursor-pointer flex items-center text-[13px] text-black`}
                  onClick={() => {
                    if (selectDataList.includes(x.content)) {
                      setSelectDataList([
                        ...selectDataList.filter(_ => _ != x.content),
                      ]);
                    } else {
                      setSelectDataList([...selectDataList, x.content]);
                    }
                  }}
                >
                  <div
                    className="h-[32px] px-[10px] rounded-[10px] flex justify-center items-center leading-[32px]"
                    style={
                      checked
                        ? {
                            background: '#000',
                            fontWeight: 'bold',
                            border: '1px solid transparent',
                          }
                        : { color: '#000', border: '1px solid rgba(0,0,0,0.1)' }
                    }
                  >
                    {x.content}
                  </div>
                </div>
              );
            })}
        </div>
        <textarea
          className="w-full h-[88px] mb-[12px] p-[10px] bg-[#F6F7F9] rounded-[10px] resize-none block"
          placeholder="写下更详细的情况"
          value={inputText}
          name=""
          id=""
          maxLength={200}
          onChange={e => {
            setInputText(e.target.value);
          }}
        ></textarea>
        <div className="w-full h-[32px] flex justify-end gap-[12px] text-[13px] text-black font-bold">
          <div
            className="h-full px-[18px] py-[7px] leading-18px cursor-pointer rounded-[10px] bg-[#F7F7F7] text-black font-bold text-opacity-50 hover:bg-[#F0F2F5] hover:bg-opacity-100 active:bg-[#E6E6E6] active:bg-opacity-100"
            onClick={e => {
              activeType.current == 'like'
                ? setOpen(false)
                : setNegativeOpen(false);
              activeType.current = '';
            }}
          >
            取消
          </div>
          <div
            className="linear-button h-full px-[18px] py-[7px] leading-18px cursor-pointer rounded-[10px] text-white font-bold"
            onClick={e => {
              handleSubmit(type);
            }}
          >
            提交
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="message-urm-feedback flex gap-[8px]">
      <Dropdown
        dropdownRender={() => dropList()}
        trigger="click"
        position="tr"
        open={open}
        onOpenChange={visible => {
          setOpen(visible);
          !visible && (activeType.current = '')
        }}
      >
        <Button
          icon="thumbs-up"
          className={`${activeType.current == 'like' || successType.current == 'like' ? 'active' : ''}`}
          onClick={() => {
            activeType.current = 'like';
            reset();
          }}
        />
      </Dropdown>
      <Dropdown
        dropdownRender={() => dropList()}
        trigger="click"
        position="bl"
        open={negativeOpen}
        onOpenChange={visible => {
          setNegativeOpen(visible);
          !visible && (activeType.current = '')
        }}
      >
        <Button
          icon="thumbs-down"
          className={`${activeType.current == 'dis_like' || successType.current == 'dis_like' ? 'active dis-like' : ''}`}
          onClick={() => {
            activeType.current = 'dis_like';
            reset();
          }}
        />
      </Dropdown>
    </section>
  );
}

export default observer(Feedback);
